import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import DownloadWindowsContent from '../components/DownloadWindowsContent';

export default function DownloadWindows() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        py: 3,
        px: 2,
      }}
    >
      <Card sx={{ maxWidth: 600, width: '100%', boxShadow: 6 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <DownloadIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" component="h1" gutterBottom>
              Download TimeSentinel for Windows
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Optional desktop agent for Windows. You can use the web portal without installing this app.
            </Typography>
          </Box>
          <DownloadWindowsContent />
        </CardContent>
      </Card>
    </Box>
  );
}
